import type { Load } from '@sveltejs/kit';
import { NONEXISTENT_PRODUCT_ID } from '#lib/features/checkout/constants/nonexistent-product-id.js';
import { GetEditionsCartDocument } from '#lib/websites/editions/queries/__generated__/getEditionsCart.generated.js';
import { getEditionsCartQueryVariables } from '#lib/websites/editions/utils/getEditionsCartQueryVariables/getEditionsCartQueryVariables.js';
import { getQueryKeys } from '$global/query-utils/getQueryKeys';

export const load: Load = async ({ parent }) => {
	const parentData = await parent();

	parentData.queryClient.setQueryData(
		getQueryKeys(
			GetEditionsCartDocument,
			getEditionsCartQueryVariables([NONEXISTENT_PRODUCT_ID])
		),
		{
			Editions: [],
		}
	);
};
